// Vendors
import React from 'react';
// Components
import { CancelDropModalComponent } from 'components/cancel-drop-modal/cancel-drop-modal.component';
// Constants
import { HEADER_LAYOUT_MODAL_COMPONENT_PROPS } from './constants/header-layout-modal.constants';
// Types
import { HeaderLayoutModalComponentType } from './types/header-layout-modal.component.type';

const HeaderLayoutModalComponent = ({
  onClose,
  showDropModal: showModal,
}: HeaderLayoutModalComponentType): React.JSX.Element => (
  <CancelDropModalComponent {...{ ...HEADER_LAYOUT_MODAL_COMPONENT_PROPS, showModal, onClose }} />
);

export { HeaderLayoutModalComponent };
